module.exports = __webpack_public_path__ + "static/media/about-us-nodes.397a3856.svg";